const FUSION_CORE_PREFIX = '/api/sg/v1/fusioncore';

const buildProxyPath = service => `${FUSION_CORE_PREFIX}/${service}`;

const proxyRuleConfigs = [
  [['/dxp/common-management/', '/dxp/proj/common-management/'], 'common-management'],
  [['/dxp/user-management/'], 'user-management'],
  [['/dxp/app-launch-management/'], 'app-launch-management'],
  [['/dxp/journey-builder/'], 'journey-builder'],
  [['/dxp/promotion-management/'], 'promotion-management'],
  [
    ['/dxp/product-ordering/', '/dxp/proj/product-ordering/', '/dxp/proj/order-management/'],
    'product-ordering',
  ],
  [['/dxp/subscriber-management/', '/dxp/proj/subscriber-management/'], 'subscriber-management'],
  [['/dxp/product-catalog/'], 'product-catalog-management'],
  [['/dxp/resource-inventory/', '/dxp/proj/resource-inventory/'], 'resource-inventory-management'],
  [['/dxp/customer-management/'], 'customer-management'],
  [['/dxp/account-management/'], 'account-management'],
  [['/dxp/customer-balance/'], 'customer-balance-management'],
  [['/dxp/payment-management/'], 'payment-management'],
  [['/dxp/proj/marketing-management/'], 'marketing-campaign-management'],
  [['/dxp/customer-bill/'], 'customer-bill-management'],
  [['/dxp/trouble-ticket/'], 'trouble-ticket-management'],
  [['/dxp/menu-management/'], 'menu-management'],
  [['/dxp/dashboard/'], 'dashboard'],
  [['/dxp/content-management/'], 'content-management'],
  [['/dxp/message-management/', '/dxp/advertisement/'], 'message-management'],
  [['/dxp/usage-consumption/'], 'usage-consumption'],
  [['/dxp/proj/package-advantage/'], 'package-advantage'],
  [['/dxp/page-builder/'], 'page-builder'],
  [['/dxp/agreement-management/'], 'agreement-management'],
  [['/dxp/theme-management/'], 'theme-management'],
  [['/dxp/game-management/'], 'game-management'],
  [['/dxp/game/'], 'game-management'],
  [
    [
      '/promotion/reward/',
      '/promotion/badge/',
      '/promotion/uc/',
      '/promotion/utm/',
      '/promotion/voucher/',
      '/promotion/membership/',
      '/promotion/point/',
      '/promotion/C2C/',
      '/promotion/getConfig',
      '/promotion/qryConfigItemParamValueByCode',
    ],
    'loyalty-management',
  ],
  [['/promotion/'], 'game-management'],
  [['/dxp/loyalty-management/'], 'loyalty-management'],
  [['/dxp/loyalty/'], 'loyalty-management'],
];

export const proxyRules = proxyRuleConfigs.map(([paths, service]) => ({
  paths,
  proxyPath: buildProxyPath(service),
}));

export const getProxyRulesPath = path => {
  if (path) {
    const matchedRule = proxyRules.find(rule => rule.paths.some(p => path.startsWith(p)));
    if (matchedRule) {
      return `${matchedRule?.proxyPath}${path}`;
    }
  }
  return path;
};
